<br>
<div>
    <p-table #dt [columns]="cols" [value]="committees" [paginator]="false" [autoLayout]="true">
        <ng-template pTemplate="caption">
            <p class="rubrik">Hantera Committee</p>
            <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addCommittee();">Lägg till</button></div>
            <br>
            <div>
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                <span class="ms-2">Antal poster: {{committees?.length}}</span>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input *ngSwitchCase="'abbreviation'" pInputText type="text" [value]="dt.filters['abbreviation'] ? dt.filters['abbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                </th>
                <th style="text-align: center;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
                <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuellt utskott"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)" title="Ändra aktuellt utskott"></i></span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-dialog header="Editera utskott" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-committees-edit [formdata]="formdata" (doSave)="saveCommittee($event)" (doCancel)="cancelEdit()"></app-admin-committees-edit>
</p-dialog>

<p-dialog header="Lägg till utskott" [(visible)]="displayaddcommittee" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-committees-add [formdata]="formdata" (doSave)="saveAddCommittee($event)" (doCancel)="cancelAdd()"></app-admin-committees-add>
</p-dialog>